// extracted by mini-css-extract-plugin
module.exports = {"covidSection":"_2-u2I","headerGraphic":"_253FG"};